import { render } from "./SidebarSubmenu.vue?vue&type=template&id=4e66206e"
import script from "./SidebarSubmenu.vue?vue&type=script&lang=js"
export * from "./SidebarSubmenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__